export const range = (count: number): Array<number> => {
    let items: Array<number> = [];
    for (let i = 0; i < count; i++) {
      items.push(i);
    }
    return items;
  };
  